import moment from 'moment';
import getDateOfMonth from 'ha/helpers/hadate/getDateOfMonth';

export default (start: string, end: string): number => {
  const startDate = getDateOfMonth(start);
  const diff = getDateOfMonth(end) - startDate;

  if (diff >= 0) {
    return diff;
  }

  const endMomentObject = moment(end);
  const daysInLastFullMonth = moment(
    `${endMomentObject.year()}'-'${endMomentObject.month() + 1}`,
    'YYYY-MM',
  )
    .subtract(1, 'M')
    .daysInMonth();

  if (daysInLastFullMonth < startDate) {
    return diff + startDate;
  }

  return daysInLastFullMonth + diff;
};
